import { types, flow, cast } from "mobx-state-tree"
import { inventoryBusiness } from "businesses/inventory-business"

// Dedicated store for the Inventory levels page. Kept separate from
// InventoryStore (which the Products page uses) so navigating between the two
// pages doesn't clobber each other's cached results. Holds the same shape but
// only what the levels page needs — no detail / movement state.
const InventoryViewStore = types
  .model({
    data: types.optional(types.frozen(), []),
    isLoading: types.maybeNull(types.boolean),
    customFilters: types.maybeNull(types.frozen()),
    searchText: types.maybeNull(types.string, ""),
    cachedForCompany: types.maybeNull(types.string, ""),
  })
  .views(self => ({
    get isArchivalSearch() {
      return self.customFilters?.archival_search || false
    },
    hasCacheForCompany(company) {
      return Boolean(self.cachedForCompany && self.cachedForCompany === company && (self.data?.length || self.searchText))
    },
  }))
  .actions(self => ({
    setData(data) {
      self.data = data
    },
    setSearchText(val) {
      self.searchText = val
    },
    setCustomFilters(data) {
      self.customFilters = cast(data)
    },
    setCachedForCompany(company) {
      self.cachedForCompany = company || ""
    },
    resetData() {
      self.data = []
      self.searchText = ""
      self.customFilters = null
      self.cachedForCompany = ""
    },
    loadData: flow(function* (showLoading = true) {
      if (!self.searchText) {
        self.setData([])
        return
      }

      if (showLoading) self.isLoading = true
      const searchParams = { ...(self.customFilters || {}) }
      const data = yield inventoryBusiness.getInventory(searchParams)
      self.setData(data)
      if (showLoading) self.isLoading = false
    }),
  }))

export default InventoryViewStore
